import {Location} from '@angular/common';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseClientService} from './base-client.service';
import {ConfigService} from './config.service';
import {Observable, Subject, throwError} from 'rxjs';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import {ErrorModel} from '../../model/error.model';
import {UsuarioModel} from '../../model/usuario.model';
import {redirectTo, urlEncode} from '../util/functions';
import axios from 'axios';
import {Router} from '@angular/router';
import jwt_decode from 'jwt-decode';
import {ToastController} from '@ionic/angular';
import {AcessoService} from './acesso.service';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private toast: any;
    user: UsuarioModel;

    private gettingOut$: Subject<string> = new Subject<string>();

    constructor(
        private location: Location,
        private client: BaseClientService,
        private configService: ConfigService,
        private router: Router,
        private http: HttpClient,
        private toastCtrl: ToastController,
        private acessoService: AcessoService,
    ) {
    }

    /**
     * Retorna o Observable com a URL de saida do sistema
     */
    gettingOutEvent(): Observable<string> {
        return this.gettingOut$.asObservable();
    }

    isAuthenticated(): Observable<boolean> {
        return this.configService.get('backendUrl').pipe(
            switchMap((backendUrl: string) => {
                console.log('[AuthService::isAuthenticated] Vamos verificar se já está autenticado');

                const request$ = this.client.get<any>(`/oauth/verify`).pipe(
                    take(1),
                    catchError((error: ErrorModel) => {
                        if (error.code === 401) {
                            console.warn('[AuthService::isAuthenticated] Não está autenticado');
                        } else if (error.code === 403) {
                            console.warn('[AuthService::isAuthenticated] Acesso proíbido cadastrado');
                        } else {
                            console.warn('[AuthService::isAuthenticated] Ops, erro na verificação', error);
                        }
                        return throwError(error);
                    }),
                    map((result: boolean) => {
                        console.log('[AuthService::isAuthenticated] Acessou a URL do backend de boa!', result);
                        if (!result) {
                            throw result;
                        }
                        return result;
                    }),
                );
                return request$;
            }),
        );
    }

    login(): void {
        const backendUrl = environment.backendUrl;
        const returnPath = this.location.path(true) || '';
        const frontendUrl = urlEncode(`${environment.frontendUrl}${returnPath}`);
        const autorizeUrl = `${backendUrl}/oauth/authorize?redirect_uri=${frontendUrl}&force_login=true`;
        console.log('[AuthService::redirectToAuthorize] Redirecionando para autorizar:', autorizeUrl);
        this.getOut(autorizeUrl);
    }

    getOut(url: string): void {
        this.gettingOut$.next(url);
        this.user = null;
        setTimeout(() => redirectTo(url), 1000);
    }

    async redirectLogin() {

        const instance = axios.create({
            withCredentials: true
        });


        const response = await instance.get(`${environment.backendUrl}/oauth/verify`)
            .catch(e => {

                throw e;
            });

        // let result = await this.client.get(`/oauth/authorize?redirect_uri=${environment.urlApp}`).toPromise();
        console.log('result', response.data);
        // window.open(environment.backendUrl+'/oauth/authorize?redirect_uri='+environment.urlApp, '_self');
    }

    verifyToken(): Promise<boolean> {

        const request$ = this.client.get<boolean>(`/oauth/verify`).pipe(
            take(1),
            catchError((error: ErrorModel) => {
                if (error.code === 401) {
                    console.warn('[AuthService::isAuthenticated] Não está autenticado');
                } else if (error.code === 403) {
                    console.warn('[AuthService::isAuthenticated] Acesso proíbido cadastrado');
                } else {
                    console.warn('[AuthService::isAuthenticated] Ops, erro na verificação', error);
                }
                return throwError(error);
            }),
            map((result: boolean) => {
                console.log('[AuthService::isAuthenticated] Acessou a URL do backend de boa!', result);
                if (!result) {
                    throw result;
                }
                return result;
            }),
        ).toPromise();
        return request$;
    }

    async verifyLogin() {
        try {
            const result: any = await this.http.get(`${environment.backendUrl}/accessToken`, {
                responseType: 'text',
                withCredentials: true
            }).toPromise();

            console.log(result);
            if (result) {
                localStorage.setItem('token', result);
                await new Promise(resolve => setTimeout(resolve, 1000));
                console.log(JSON.stringify(localStorage.getItem('token')));
                const decodeToken = this.decodePayloadJWT();
                if (decodeToken) {
                    localStorage.setItem('tokenExpDate', decodeToken.exp);
                    const user = await this.getUserByCpf(decodeToken.user_name).toPromise();
                    const userStringfy = JSON.stringify(user);
                    localStorage.setItem('userLogged', userStringfy);
                }
                const perfis = await this.acessoService.getPerfil();
                if (perfis.length > 0) {
                    this.router.navigate([`/home`]);
                } else {
                    const toast = await this.toastCtrl.create({
                        position: 'top',
                        message: 'Usuário e senha não autorizados no SCPA.',
                        color: 'danger',
                        duration: 1000
                    });
                    toast.present();
                }
            }

        } catch (err) {
            console.log('Erro => ', err);
        }


        // await this.client.get<boolean>(`/oauth/verify`).pipe(
        //   take(1),
        //   map((result: boolean) => {
        //     console.log('result', result)
        //     if (result) {
        //       this.router.navigate([`/home`]);
        //     }
        //   }),
        // ).subscribe();
    }

    async refreshToken() {
        return this.client.get(`/oauth/refreshToken`, undefined, undefined, 'text').toPromise();
    }

    getUserByCpf(cpf: string) {
        return this.client.get(`/cmd-cadsus/v1/usuario/cpf?cpf=${cpf}`);
    }

    decodePayloadJWT(token?: string): any {
        try {
            if (!token) {
                token = localStorage.getItem('token');
            }
            return jwt_decode(token);
        } catch (Error) {
            return null;
        }
    }
}
